export const environment = {
  production: false,
  env: 'prod',
  msalConfig: {
    auth: {
      clientId: 'cab98224-bed2-4434-9f63-9277e2618af2',
      authority:
        'https://login.microsoftonline.com/5b973f99-77df-4beb-b27d-aa0c70b8482c',
    },
  },
  apiConfig: {
    scopes: ['user.read'],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
  apiUrl: 'https://api.cit-agent.ey.net/',
};
